<template>
  <div class="qs-layout__header">
    <div
      style="float: left; height: 60px; margin-left: 40px; line-height: 60px"
    >
      <span class="logo"></span>
      <span class="currentTime">
        <span>{{ $t("common.currentTime") }}：{{ date }}</span>
      </span>
    </div>
    <div class="header-menu">
      <!-- <el-popover placement="top-start" width="50" trigger="hover">
      <span @click="logout" class="pointer">
        {{ $t(`header.logout`) }}
      </span>
      <div class="authfr circle" slot="reference">
        <span class="shezhiIcon"></span>
      </div>
    </el-popover>
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t(`header.mainPage`)"
      placement="bottom"
    >
      <div @click="toMain" class="authfr circle">
        <span class="shouyeIcon"></span>
      </div>
    </el-tooltip> -->
      <el-tooltip
        v-if="!main"
        class="item"
        effect="dark"
        :content="$t(`header.mainPage`)"
        placement="bottom"
      >
        <div
          class="qs-headerMenu__icon"
          @click="toMain"
          style="margin-right: 10px"
        >
          <span class="shouyeIcon"></span>
        </div>
      </el-tooltip>
      <el-dropdown @command="handleCommand">
        <div class="qs-headerMenu__icon">
          <span class="shezhiIcon"></span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="logout" :command="0">{{
              $t(`header.logout`)
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    main: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      date: "",
    };
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    _this.date = this.dateFormat("YYYY-mm-dd HH:MM", new Date());
    this.timer = setInterval(() => {
      _this.date = this.dateFormat("YYYY-mm-dd HH:MM", new Date()); // 修改数据date
    }, 1000);
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    toMain() {
      // this.$router.push({ path: "/main" });
      location.href = "/main";
    },
    handleCommand(cmd) {
      switch (cmd) {
        case 0:
          this.logout();
      }
    },
    logout() {
      this.$store.commit("common/RESET_LIST");
      //将上次登录信息清除
      this.$store.commit("login/RESET_STATE");
      //清除本地存储
      localStorage.clear();
      sessionStorage.clear();
      //令牌过期,令牌格式错误，未登录
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less">
.header-menu {
  float: right;
  height: 60px;
  line-height: 50px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  .qs-headerMenu__icon {
    padding: 5px;
    width: 16px;
    height: 16px;
    display: inline-block;
    border: 1px #f5f7fa solid;
    border-radius: 50%;
    line-height: 16px;
    cursor: pointer;
    background: #f5f7fa;
  }
}
.logo {
  height: 24px;
  width: 81px;
  display: inline-block;
  background: url("../../static/images/login/logo.png");
  background-position: right;
  vertical-align: middle;
}
.currentTime {
  margin-left: 40px;
  font-size: 12px;
  color: #303133;
  font-weight: 400;
}
</style>
